export default __webpack_public_path__ + "static/media/feat_iamnoself.fd338f64.jpg";